export const adjustTimestamp = (isoTimestamp) => {
  const date = new Date(isoTimestamp);
  const localOffsetInMillis = date.getTimezoneOffset() * 60 * 1000;
  const adjustedTimestamp = date.getTime() - localOffsetInMillis; // Adjust for local time
  const adjustedDate = new Date(adjustedTimestamp);
  return adjustedDate;
};
